import { createAsyncThunk } from '@reduxjs/toolkit'
import { APIError, get, put, remove } from '@user/store/services/crud'
import { ServiceConfig } from '@user/store/services/config'
import {
  IAutoReviewAdditionalField,
  IAutoReviewAdditionalFieldInput,
  IAutoReviewSettingsDTO,
  IAutoReviewSettingsInput,
} from './typings'

const url = `${ServiceConfig.baseAPIUrl}${ServiceConfig.autoReviewSettings.autoReviewSettings}`
const additionalFieldsUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.autoReviewSettings.additionalRequiredFields}`

export const getAutoReviewSettings = createAsyncThunk<
  IAutoReviewSettingsDTO,
  void,
  { rejectValue: APIError }
>('autoReviewSettings/get', async (_, thunkApi) => {
  const response = await get(url)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const updateAutoReviewSettings = createAsyncThunk<
  IAutoReviewSettingsDTO,
  IAutoReviewSettingsInput,
  { rejectValue: APIError }
>('autoReviewSettings/update', async (input, thunkApi) => {
  const response = await put(url, input)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const getAdditionalRequiredFieldOptions = createAsyncThunk<
  IAutoReviewAdditionalField[],
  void,
  { rejectValue: APIError }
>('autoReviewSettings/getAdditionalOptions', async (_, thunkApi) => {
  const response = await get(additionalFieldsUrl)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const addAdditionalRequiredFields = createAsyncThunk<
  void,
  IAutoReviewAdditionalFieldInput[],
  { rejectValue: APIError }
>('autoReviewSettings/addAdditional', async (input, thunkApi) => {
  const response = await put(additionalFieldsUrl, input)
  if (response.ok) return
  return thunkApi.rejectWithValue(await response.json())
})

export const removeAdditionalRequiredField = createAsyncThunk<
  void,
  IAutoReviewAdditionalFieldInput,
  { rejectValue: APIError }
>('autoReviewSettings/removeAdditional', async (input, thunkApi) => {
  const response = await remove(additionalFieldsUrl, input)
  if (response.ok) return
  return thunkApi.rejectWithValue(await response.json())
})
